<script>
import CurrencyField from '@/components/CurrencyField/CurrencyField.vue';
import VTextField from 'vuetify/lib/components/VTextField';

import {
  addQzDirectives,
  ATTRS_FOR_NUM_KEYBOARD,
  QZ_INPUT_STYLE,
} from '@/constants/common';

export default {
  name: 'qz-number-input',
  functional: true,
  render (h, context) {
    function handleWheelEventOnNumberInput () {
      this.blur();
    };

    // this component listeners with modified keypress event to work as v-model
    const updatedListeners = Object.assign({},
      context.listeners,
      {
        keypress (event) {
          const key = event.which || event.keyCode;

          if (!String.fromCharCode(key).match(/^[0-9]+$/)) {
            event.preventDefault();
            return false;
          }

          let value = context.data.attrs.value;

          if (context.props.withoutSeparators) {
            value = event.target.value;
          }

          const hasMaxLength = !!context.data.attrs?.maxlength;
          const maxLength = context.data.attrs.maxlength;
          const length = [null].includes(value) ? 0 : `${value}`.length;
          // limit input chars
          if (hasMaxLength && length >= maxLength) {
            event.preventDefault();
          }

          context.listeners.input(value);
        },
        keydown (event) {
          const key = event.which || event.keyCode;

          const isArrowUpPressed = +key === 38;
          const isArrowDownPressed = +key === 40;

          if (isArrowUpPressed || isArrowDownPressed) {
            const value = event.target.value;

            const hasMaxLength = !!context.data.attrs?.maxlength;
            const maxLength = context.data.attrs.maxlength;
            const maxValue = +Array.from(Array(maxLength).keys()).map(() => 9).join('');
            const minValue = 0;

            // limit input chars by press arrows
            if (hasMaxLength && ((isArrowDownPressed && value <= minValue) || (isArrowUpPressed && value >= maxValue))) {
              event.preventDefault();
            }

            context.listeners.input(value);
          }
        },
        focus (event) {
          event.target.addEventListener('wheel', handleWheelEventOnNumberInput);
          context.listeners.focus && context.listeners.focus(event);
        },
        blur (event) {
          event.target.removeEventListener('wheel', handleWheelEventOnNumberInput);
          context.listeners.blur && context.listeners.blur(event);
        },
      },
    );

    const field = context.props.withoutSeparators ? VTextField : CurrencyField;

    return h(field, {
      attrs: {
        // add to attributes passed to this component attributes for number input ( to display proper keyboard on mobile devices )
        ...context.data.attrs, ...ATTRS_FOR_NUM_KEYBOARD, ...QZ_INPUT_STYLE,
      },
      ref: context.data.ref,
      domProps: {
        // updated v-model
        value: context.data.model.value,
      },
      on: {
        ...updatedListeners,
      },
      directives: addQzDirectives(context.data),
    });
  },
};
</script>
